/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DeckKYC {
  readonly id: string;
  readonly question: string;
  readonly answer_text: string;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
}
